<template>
	<div class="popup-email__wrap">
		<transition name="fade-popup-email" appear>
		<!--v-on-click-outside="closePopupEmail"-->
			<div class="popup-email">
			<div class="popup-email-close-icon close-icon" ref="cancelBtnIcon" @click="closePopupEmail">
				<SvgIcon iconName="ico-close-sm"/>
			</div>
			<div class="popup-email-notif" v-if="uploading">
				<span class="popup-email-uploading-file">Please wait, the file is being uploaded...</span>
			</div>
				<form>
					<div class="popup-email__container">
						<div class="popup-email__container-header">
							<span class="popup-email__title section-title">Send Email</span>
							<div class="popup-email__emails" v-on-click-outside="checkEmailValue">
								<div class="new-customer-form__input-box new-customer-form__input-box--full-width">
									<div class="new-customer-form__input new-customer-form__input--email">
										<PartInputEmails v-model="email" :data="DataEmail" :to="email"/>
										<span class="email-option">
											<span class="email-option-link" ref="ccField" @click="showCcField">Cc</span>
											<!-- <span class="email-option-link" ref="bccField" @click="showBccField">Bcc</span> -->
										</span>
									</div>
								</div>
								<transition name="slide-fade" appear>
									<div class="new-customer-form__input-box new-customer-form__input-box--full-width" ref="cc_email" v-if="emailFiledCc">
										<div class="new-customer-form__input">
											<PartInputEmails v-model="email_cc" :data="DataCcEmails" :cc="cc"/>
										</div>
									</div>
								</transition>
								<transition name="slide-fade" appear>
									<div class="new-customer-form__input-box new-customer-form__input-box--full-width" ref="bcc_email" v-if="emailFiledBcc">
										<div class="new-customer-form__input">
											<PartInputEmails v-model="email_bcc" :data="DataBccEmails" :bcc="bcc"/>
										</div>
									</div>
								</transition>
							</div>
							<div class="popup-email__pdf">
								<div class="popup-email_uploadfile popup-email__header">
									<div class="popup-email-upload">
										<div class="popup-email--pdf-file">
											<span class="input-label">Upload File:</span>
											<div class="popup-email-upload-file">
												<div class="upload-btn-wrapper" v-if="!uploadedPDF">
													<div class="btn">
														<span class="upload-btn-wrapper-inner">
															<SvgIcon
																class="add-pdf-icon"
																iconName="ico-plus"
															/>
															<span>Add File</span>
														</span>
													</div>
													<input @change="onFileChange" @dragover="dragover" ref="file" type="file" name="pdfFile"/>
												</div>
												<div class="uploaded-file" v-else>
													<span class="uploaded-file-info">{{ uploadedPDFName }}</span>
													<span class="remove-file" @click="removeImage()">
														<SvgIcon
															class="remove-pdf-icon"
															iconName="ico-close-sm"
														/>
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="popup-email__wrap-box popup-email__pdf-btn popup-email__header">
									<PartCheckboxDropdown v-model="selectedPDF" ref="pdf" :data="DataPdf"/>
								</div>
							</div>
						</div>
						<div class="popup-email__radio-wrap">
							<PartRadioButton v-model="markedStage" :data="DataRadioButton"/>
						</div>
						<div class="popup-email__container-body">
							<ckeditor :editor="editor" v-model="emailBody" :config="editorConfig"></ckeditor>
						</div>
					</div>
					<div class="property-form__bottom-button">
						<a class="btn property-form__bottom-btn" :class="{'property-form__bottom-btn--disabled': !disableSaveBtn() }" id="save_property-button-bottom" @click="sendEmail()">
							<span>Send</span>
						</a>
						<a class="btn btn--white property-form__bottom-btn btn--cancel" id="cancel_property-button-bottom" ref="cancelBtn" @click="closePopupEmail()">
							Cancel
						</a>
					</div>
				</form>
			</div>
		</transition>
		<transition name="fade-popup-email" appear>
			<div class="confirme-popup" v-if="closeEmailPopup">
				<div class="confirme-popup-overlay"></div>
				<div class="confirme-popup-inner">
					<span class="confirme-popup-text section-title">
						Are you sure you want to quit?
					</span>
					<div class="confirme-popup-button">
						<a class="btn confirme-popup-btn" @click="confirmeClosePopup()">
							<span>Yes</span>
						</a>
						<a class="btn btn--white confirme-popup-btn" @click="cancelClosePopup()">
							No
						</a>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside';
import PartCheckboxDropdown from '@/components/parts/PartCheckboxDropdown';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartRadioButton from '@/components/parts/PartRadioButton';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import PartInputEmails from '@/components/parts/PartInputEmails';

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		isHistory: {
			type: Boolean,
			default: true
		},
		propPDF: {
			type: String,
			default: ''
		}
	},
	components: {
		PartCheckboxDropdown,
		SvgIcon,
		PartRadioButton,
		PartInputEmails
	},
	data () {
		return {
			closeEmailPopup: false,
			cc: null,
			bcc: null,
			to: null,
			emailFiledCc: false,
			emailFiledBcc: true,
			editor: ClassicEditor,
			unpersonalizedPDF: '',
			uploading: false,
			editorConfig: {
				toolbar: {
					items: ['undo', 'redo', '|', 'bold', 'italic', '|', 'numberedList', 'bulletedList'],
					shouldNotGroupWhenFull: false
				}
			},
			DataEmail: {
				label: 'To',
				placeholder: 'Enter Email'
			},
			DataCcEmails: {
				label: 'Cc',
				placeholder: 'Enter Email'
			},
			DataBccEmails: {
				label: 'Bcc',
				placeholder: 'Enter Email'
			},
			DataPdf: {
				label: 'Select PDF version',
				placeholder: 'Add PDF',
				labelId: 'select-pdf-label',
				inputId: 'select-pdf-input',
				searchable: true,
				mandatoryFiled: true,
				options: [
					{
						id: 'agent',
						label: 'Agent Version'
					},
					{
						id: 'client',
						label: 'Client Version'
					}
				],
				multiple: false
			},
			DataRadioButton: {
				label: 'Mark selected as:',
				labelId: 'radio-status-label',
				id: 'radio-status-input',
				defaultValue: 'emailed',
				lists: [
					{
						for: 'no_follow_up-radio',
						id: 'no_follow_up-radio',
						value: 'no_follow_up',
						name: 'stageMarker',
						label: 'No Follow-up'
					},
					{
						for: 'emailed_radio',
						id: 'emailed_radio',
						value: 'emailed',
						name: 'stageMarker',
						label: 'Emailed'
					}
				]
			},
			emailBody: '',
			uploadedPDF: '',
			uploadedPDFName: '',
			selectedPDF: '',
			markedStage: 'emailed',
			deleteClicked: false,
			email: [],
			email_cc: '',
			email_bcc: ''
		};
	},
	mixins: [onClickOutside],
	mounted() {
		let cid;
		if (this.data.pivot.customer_id) {
			cid = this.data.pivot.customer_id;
		} else {
			cid = this.data.blastEmail.customers_id;
		}
		this.$store.dispatch('fetchCustomer', cid).then(res => {
			let customers = res.data.customer;
			if (!Array.isArray(customers)) {
				customers = [customers];
			}
			this.email = [];
			this.bcc = [];
			this.to = [];
			this.cc = [];
			const agent = JSON.parse(localStorage.getItem('user'));
			customers.forEach(customer => {
				if (customer.first_name && !this.data.sendBlast) {
					this.emailBody = `${customer.first_name},`;
				}
				if (customer && this.data.sendBlast) {
					if (agent && agent.email && agent.alternative_email) {
						if (!this.email.includes(agent.email)) {
							this.email.push(agent.email);
						}
						// if (!this.email.includes(agent.alternative_email)) {
						// 	this.email.push(agent.alternative_email);
						// }
					} else if (agent && !agent.email && agent.alternative_email) {
						if (!this.email.includes(agent.alternative_email)) {
							this.email.push(agent.alternative_email);
						}
					} else {
						if (!this.email.includes(agent.email)) {
							this.email.push(agent.email);
						}
					}
					if (customer.primary_email && customer.secondary_email) {
						this.bcc.push(customer.primary_email, customer.secondary_email);
					} else if (customer.secondary_email) {
						this.bcc.push(customer.secondary_email);
					} else {
						this.bcc.push(customer.primary_email);
					}
					this.to = this.bcc;
				} else {
					if (agent && agent.email && agent.alternative_email) {
						// if (!this.bcc.includes(agent.email)) {
						// 	this.bcc.push(agent.email);
						// }
						if (!this.bcc.includes(agent.alternative_email)) {
							this.bcc.push(agent.alternative_email);
						}
					}
					if (customer.primary_email && customer.secondary_email) {
						this.email.push(customer.primary_email, customer.secondary_email);
					} else if (customer.secondary_email) {
						this.email.push(customer.secondary_email);
					} else {
						this.email.push(customer.primary_email);
					}
					this.to = this.email;
				}			
			});
		});
		const flyerUrl = this.propertyInfo?.unpersonalized_pdf_url?.split('/');
		this.unpersonalizedPDF = this.propPDF || this.propertyInfo?.unpersonalized_pdf_url;
		if ((this.propertyInfo.unpersonalized_pdf_url && flyerUrl[flyerUrl.length - 1].toLowerCase().includes('.pdf')) || this.propPDF !== '') {
			this.DataPdf.options.push({
				id: 'eretz_flyer',
				label: 'Eretz Flyer'
			});
		}
		const self = this;
		self.$root.$on('delete-email', function(data) {
			if (data.type === 'bcc') {
				self.email_bcc.splice(data.index, 1);
			} else if (data.type === 'to') {
				self.email.splice(data.index, 1);
			}
		});
	},
	computed: {
		propertyInfo() {
			return this.$store.getters.getPropertyInfo;
		},
		allStages() {
			return this.$store.getters.getStages;
		}
	},
	methods: {
		confirmeClosePopup(notification) {
			this.$emit('closePopupEmail', notification);
			this.closeEmailPopup = false;
		},
		cancelClosePopup() {
			this.closeEmailPopup = false;
		},
		resizeImage(base64Str, maxWidth = 400, maxHeight = 350) {
			return new Promise((resolve) => {
				const img = new Image();
				img.src = base64Str;
				img.onload = () => {
					const canvas = document.createElement('canvas');
					const MAX_WIDTH = maxWidth;
					const MAX_HEIGHT = maxHeight;
					let width = img.width;
					let height = img.height;

					if (width > height) {
						if (width > MAX_WIDTH) {
							height *= MAX_WIDTH / width;
							width = MAX_WIDTH;
						}
					} else {
						if (height > MAX_HEIGHT) {
							width *= MAX_HEIGHT / height;
							height = MAX_HEIGHT;
						}
					}
					canvas.width = width;
					canvas.height = height;
					const ctx = canvas.getContext('2d');
					ctx.drawImage(img, 0, 0, width, height);
					resolve(canvas.toDataURL());
				};
			});
		},
		disableSaveBtn() {
			return (this.emailBody.length > 0 && (this.selectedPDF.length > 0 || this.uploadedPDF.length > 0));
		},
		closePopupEmail() {
			// this.$emit('closePopupEmail', notification);
			this.closeEmailPopup = true;
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			this.uploadedPDFName = files[0].name;
			if (!files.length) {
				this.deleteClicked = false;
			} else {
				this.createDocument(files[0]);
				this.deleteClicked = true;
			}
		},
		dragover(event) {
			event.preventDefault();
		},
		createDocument(file) {
			const vm = this;
			const reader = new FileReader();
			reader.onload = (e) => {
				if (file && file.type !== 'application/pdf') {
					vm.resizeImage(e.target.result).then(function(image) {
						vm.uploadedPDF = image;
						file = image;
					});
				} else {
					vm.uploadedPDF = e.target.result;
				}
			};
			reader.readAsDataURL(file);
		},
		removeImage: function () {
			this.uploadedPDFName = '';
			this.uploadedPDF = '';
			this.deleteClicked = false;
		},
		async sendEmail() {
			this.$emit('sendingEmail');
			this.closeEmailPopup = false;
			this.$refs.cancelBtn.classList.add('disabled-btn');
			this.$refs.cancelBtnIcon.classList.add('disabled-btn');

			const obj = {
				email_body: this.emailBody,
				file: this.uploadedPDF,
				pdf: this.selectedPDF,
				stage: this.markedStage,
				origin: this.data.pivot.origin,
				active_filters: this.data.active_filters,
				user_id: JSON.parse(localStorage.getItem('user')).id,
				email: this.email,
				email_bcc: this.email_bcc,
				email_cc: this.email_cc,
				custom_flyer_url: this.unpersonalizedPDF || ''
			};
			if (this.data.sendBlast) {
				obj.property_id = this.data.blastEmail.property_id;
				obj.customer_id = this.data.blastEmail.customers_id;
			} else {
				obj.property_id = this.data.pivot.property_id;
				obj.customer_id = [this.data.pivot.customer_id];
			}
			if (obj.pdf) {
				this.uploading = true;
			}
			await this.$store.dispatch('sendPDF', obj).then(async (result) => {
				if (this.data.pivot.origin === 'customer') {
					const payload = {
						order_by: 'title',
						order: 'asc',
						id: this.$route.params.id,
						page: 1
					};
					await this.$store.dispatch('emailUpdateCustomers', { obj, allStages: this.allStages, payload });
					this.$emit('afterSendEmail');
				} else {
					const payload = {
						order_by: 'last_name',
						order: 'asc',
						id: this.$route.params.id,
						page: 1
					};
					await this.$store.dispatch('emailUpdateProperties', { obj, allStages: this.allStages, payload });
					this.$emit('afterSendEmail');
				}

				const notification = {};

				if (result.data.status === 'email_with_pdf_sent') {
					notification.message = result.data.message;
					notification.status = 200;
				} else {
					notification.message = result.data.message;
					notification.status = 400;
				}
				this.uploading = false;
				this.closePopupEmail(notification);
				this.$emit('closePopupEmail');
				this.closeEmailPopup = false;
				this.$refs.cancelBtn.classList.remove('disabled-btn');
				this.$refs.cancelBtnIcon.classList.remove('disabled-btn');
			});
			this.$store.dispatch('resetCustomPropertiesChangeStage');
		},
		showCcField() {
			this.emailFiledCc = true;
			this.$refs.ccField.classList.add('hide-link');
		},
		showBccField() {
			this.emailFiledBcc = true;
			this.$refs.bccField.classList.add('hide-link');
		},
		checkEmailValue() {
			if (this.email_cc && this.email_cc.length < 1) {
				this.emailFiledCc = false;
				this.$refs.ccField.classList.remove('hide-link');
			}
			if (this.email_bcc && this.email_bcc.length < 1) {
				this.emailFiledBcc = false;
				this.$refs.bccField.classList.remove('hide-link');
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.popup-email__wrap {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	z-index: 999999;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba($slate-gray, .5);
}
.popup-email {
	max-width: 600px;
	padding: 50px 40px;
	width: 100%;
	background-color: $white;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-shadow: 0 2px 4px rgba($black, .25);
	border-radius: 8px;
	max-height: 80vh;
	/*overflow: auto;*/
	position: relative;

	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}

	&::-webkit-scrollbar-track {
		background: #eceeef;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #42526e;
		border-radius: 20px;
		border: 1px solid #eceeef;
	}
	scrollbar-width: thin;
	scrollbar-color: #42526e #eceeef;

	form {
		overflow: auto;
		width: 100%;
		padding-bottom: 30px;

		&::-webkit-scrollbar {
			width: 12px;
			height: 12px;
		}

		&::-webkit-scrollbar-track {
			background: #eceeef;
		}

		&::-webkit-scrollbar-thumb {
			background-color: #42526e;
			border-radius: 20px;
			border: 1px solid #eceeef;
		}
		scrollbar-width: thin;
		scrollbar-color: #42526e #eceeef;

		@include mq($lg) {
			padding: 0 15px 30px;
		}
	}

	@include mq($lg) {
		padding: 40px 15px;
	}

	@include mq($md) {
		top: 100px;
	}

	@include mq($sm) {
		top: 80px;
		position: absolute;
		height: 80vh;
		max-width: 95%;
	}
}

.popup-email__title {
	margin-bottom: 25px;
	font-size: 20px;
	max-width: 100%;
	width: 100%;

	@include mq($lg) {
		font-size: 18px;
		margin-bottom: 20px;
	}

	@include mq($md) {
		font-size: 17px;
	}
}

.popup-email__btn-wrap {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 50px;
	max-width: 100%;
	width: 100%;

	@include mq($lg) {
		padding: 0 30px;
		justify-content: space-around;
	}

	@include mq($sm) {
		padding: 0 20px;
	}
}

.popup-email__btn {
	@include mq(400px) {
		padding: 5px;
		max-width: 100px;
	}
}

.popup-email__container {
	display: flex;
	align-items: flex-start;
	justify-content: space-around;
	flex-direction: column;
	padding-right: 15px;

	@include mq($sm) {
		padding-right: 0;
		overflow: hidden;
	}
}

.popup-email__container-header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	flex-wrap: wrap;
	width: 100%;
	transition: $dur $ease;
}

.popup-email-button {
	position: relative;
	min-width: 179px;
	width: 100%;
	border-radius: 8px;
	border: 1px solid $fiord;
	background-color: $white;
	color: $fiord;
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 1;
	outline: none;
	cursor: pointer;
}

.popup-email-btn {
	width: 100%;
	display: flex;
	align-items: center;
	border: none;
	padding: 16px 11px;
}

.popup-email-btn:after {
	content: "";
	width: 0;
	height: 0;
	position: absolute;
	right: 16px;
	top: calc(50% + 4px);
	margin-top: -6px;
	border-width: 6px 6px 0 6px;
	border-style: solid;
	border-color: $fiord transparent;
	transition: $dur $ease;
}

.popup-email__dropdown {
	position: absolute;
	z-index: 10;
	top: 98%;
	left: -1px;
	right: 0;
	font-weight: normal;
	list-style-type: none;
	padding-left: 0;
	margin: 0;
	border: 1px solid $fiord;
	border-top: 0;
	background-color: $white;
	transition: $dur $ease;
	width: 100.9%;
}

.popup-email__dropdown-item {
	display: block;
	text-decoration: none;
	color: $fiord;
	cursor: pointer;
	transition: $dur $ease;

	&:not(:last-of-type) {
		border-bottom: 1px solid $grey-light;
	}

	@include hover {
		background-color: $athens-gray;
		.popup-email__dropdown-link {
			color: $dodger-blue;
		}
	}
}

.popup-email__file-icon {
	padding: 0;
	font-size: 18px;
	margin-right: 12px;
	transition: $dur $ease;
}

.popup-email__dropdown-link {
	font-family: $font-main;
	font-size: 14px;
	padding: 10px;
	display: block;
	color: $fiord;
	transition: $dur $ease;
	text-decoration: none;
}

.popup-email__wrap-box {
	width: 100%;
}

.popup-email__pdf-btn {
	max-width: 40%;
	margin-left: 20px;

	@include mq($md) {
		margin-left: 0;
		max-width: 100%;
	}
}

.popup-email__pdf {
	max-width: 100%;
	width: 100%;
	display: flex;

	@include mq($md) {
		flex-direction: column;
	}
}

.property-form__bottom-button {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-right: 15px;

	@include mq($sm) {
		padding-right: 0;
	}
}

.property-form__bottom-btn {
	@include mq($md) {
		min-width: 100px;
	}

	@include mq($sm) {
		min-width: 93px;
	}

	&:not(:first-child) {
		margin-left: 14px;

		@include mq($md) {
			margin-left: 20px;
		}
	}

	&--disabled {
		opacity: .5;
		pointer-events: none;

		&:hover {
			color: $white;
			background-color: $dodger-blue;
		}
	}
}

.popup-email--pdf-file {
	margin-bottom: 29px;

	@include mq($lg) {
		margin-bottom: 20px;
	}
}

.popup-email-upload-file {
	margin-top: 7px;
}

.upload-btn-wrapper {
	position: relative;
	cursor: pointer;
	max-width: 100%;
	width: 100%;
	height: 50px;
    margin: auto 0;
    display: flex;

	@include mq($lg) {
		max-width: 208px;
	}

	.btn {
		max-width: 100%;
	}
}

.uploaded-file {
	display: flex;
	position: relative;
	border: 2px dashed #7a869a;
	box-sizing: border-box;
	border-radius: 8px;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 20px;
	padding: 11px 5px 11px 10px;
}

.remove-pdf-icon {
	cursor: pointer;
	transition: $dur $ease;
	color: $fiord;

	@include hover {
		color: $dodger-blue;
	}
}

.upload-btn-wrapper input[type=file] {
	font-size: 23px;
	cursor: pointer;
	position: absolute;
	left: 0;
	top: 0;
	opacity: 0;
	height: 100%;
	width: 100%;
}

.upload-btn-wrapper-inner {
	display: flex;
	align-items: center;
}

.uploaded-file-info {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.remove-file {
	height: 20px;
}

.add-pdf-icon,
.remove-pdf-icon {
	font-size: 16px;
	height: 16px;
}

.add-pdf-icon {
	margin-right: 10px;
}

.popup-email__header {
	max-width: 48%;
	width: 100%;

	@include mq($md) {
		max-width: 100%;
	}
}

.popup-email__radio-wrap {
	max-width: 100%;
	width: 100%;
	transition: $dur $ease;
}

/* Emails */
.new-customer-form__input {
	position: relative;
}
.popup-email__emails {
	max-width: 100%;
    width: 100%;
}

.email-option {
	position: absolute;
    right: 8px;
    bottom: 81%;
	padding: 2px;
    font-size: 12px;
	z-index: 5;
	transition: $dur $ease;
	color: $fiord;
	background-color: $white;

	&.showDeleteIcon {
		opacity: 1;
	}

	@include hover {
		color: $mine-shaft;
	}
}

.email-option-link {
	font-size: 14px;
	transition: $dur $ease;
	color: $fiord;
	display: inline-block;
	cursor: pointer;

	@include hover {
		color: $dodger-blue;
	}

	&.hide-link {
		opacity: 0;
		display: none;

	}

	&:not(:last-of-type) {
		margin-right: 5px;
	}
}

.tags__box {
	/deep/ input {
		min-width: auto;
		width: auto;
	}

	/deep/ .tags {
		padding: 11px 52px 11px 19px;
	}
}

.slide-fade-enter-active {
	transition: all .2s ease;
}
.slide-fade-leave-active {
	transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
	transform: translateX(10px);
	opacity: 0;
}

.popup-email__container-body {
	transition: $dur $ease;
}

.popup-email-uploading-file {
	color: #EBAA02;
	font-family: $font-main;
	font-size: 12px;
	text-transform: uppercase;
	overflow: hidden;
	padding: 10px 0;
	z-index: 7;
}

.popup-email-notif {
	// display: none;
	&::before {
		content: '';
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		position: absolute;
		z-index: 7;
		background-color: rgba(255, 255, 255, 0.4);
	}
}

.confirme-popup {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	z-index: 999999;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba($slate-gray, .5);
}

.confirme-popup-inner {
	max-width: 600px;
	padding: 50px 40px;
	width: 100%;
	background-color: $white;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-shadow: 0 2px 4px rgba($black, .25);
	border-radius: 8px;
	max-height: 80vh;
	/*overflow: auto;*/
	position: relative;

	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}

	&::-webkit-scrollbar-track {
		background: #eceeef;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #42526e;
		border-radius: 20px;
		border: 1px solid #eceeef;
	}
	scrollbar-width: thin;
	scrollbar-color: #42526e #eceeef;
}

.confirme-popup-text {
	margin-bottom: 20px;
}

.confirme-popup-button {
	display: flex;
}

.confirme-popup-btn {
	min-width: 100px;
	margin: 0 10px;
}

.disabled-btn {
	pointer-events: none;
	opacity: 0.5;
}

</style>
